import { Flex } from "@chakra-ui/layout";
import { Checkbox } from "@chakra-ui/react";
import { Modal } from "antd";
import { useLoading } from "components/GlobalLoading";
import SelectContasBancariasProcessarArrecadacao from "components/Input/SelectContasBancariasProcessarArrecadacao";
import SelectMesConsumoProcessarArrecadacao from "components/Input/SelectMesConsumoProcessarArrecadacao";
import SelectPeriodoDemonstrativoProcessarArrecadacao from "components/Input/SelectPeriodoDemonstrativoProcessarArrecadacao";
import { ArrecadacaoAutomaticaParametrosForm } from "core/features/arrecadacoes/typings";
import useParametrosArrecadacaoAutomatica from "core/features/arrecadacoes/useParametrosArrecadacaoAutomatica";
import useSalvarParametrosArrecadacaoAutomatica from "core/features/arrecadacoes/useSalvarParametrosArrecadacaoAutomatica";
import { showSuccess } from "infra/helpers/alerta";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import Field from "ui/components/Input/Field";
import Toolbar from "ui/components/Toolbar";
import { ArrecadacaoDemonstrativoContasBancariasEnum } from "core/features/arrecadacoes/enums";

interface ModalParametrosArrecadacaoAutomaticaProps {
  isOpen: boolean;
  onClose: () => any;
}

function ModalParametrosArrecadacaoAutomatica({
  isOpen,
  onClose,
}: ModalParametrosArrecadacaoAutomaticaProps) {
  const { control, watch, reset, handleSubmit } =
    useForm<ArrecadacaoAutomaticaParametrosForm>({
      defaultValues: {
        mesConsumo: null,
        prefixoDescricao: null,
        incluirDemonstrativo: null,
        periodoDemonstrativo: null,
        contasBancarias: null,
      },
      mode: "all",
    });

  const { data: parametrosArrecadacao, isLoading } =
    useParametrosArrecadacaoAutomatica();
  const { mutate: salvarParametros, isLoading: isLoadingSave } =
    useSalvarParametrosArrecadacaoAutomatica();

  const onSubmit = (form: ArrecadacaoAutomaticaParametrosForm) => {
    salvarParametros(form, {
      onSuccess: () => {
        showSuccess("Parâmetros salvos com sucesso").then(() => onClose());
      },
    });
  };

  const form = watch();

  useEffect(() => {
    if (parametrosArrecadacao) {
      reset(parametrosArrecadacao);
    }
  }, [reset, parametrosArrecadacao]);

  useLoading(isLoadingSave || isLoading);
  return (
    <Modal
      destroyOnClose
      width={"600px"}
      closable={false}
      className="antd-custom-header"
      title={
        <Toolbar
          title="Configurações de processamento de arrecadações automáticas"
          onClose={onClose}
          border="0px"
        />
      }
      centered
      footer={
        <Flex gridGap={4} justifyContent="flex-end">
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>

          <PrimaryButton
            onClick={() => {
              handleSubmit(onSubmit)();
            }}
          >
            Salvar
          </PrimaryButton>
        </Flex>
      }
      visible={isOpen}
      onCancel={onClose}
    >
      <Flex flexDir="column" gap={3}>
        <Field
          tooltip="O mês da cobrança aparecerá automaticamente no final da descrição"
          control={control}
          name="prefixoDescricao"
          label="Prefixo da descrição"
          inputProps={{ placeholder: "Ex: Taxa Condominial" }}
        />

        <Field
          control={control}
          name="mesConsumo"
          label="Mês do consumo"
          render={({ field }) => (
            <SelectMesConsumoProcessarArrecadacao
              placeholder="Selecione"
              {...field}
            />
          )}
        />

        <Field
          control={control}
          name="incluirDemonstrativo"
          render={({ field }) => (
            <Checkbox
              isChecked={field.value}
              onChange={(e) => field.onChange(!field.value)}
            >
              Incluir demonstrativo de receitas e despesas no boleto?
            </Checkbox>
          )}
        />

        {form.incluirDemonstrativo && (
          <>
            <Field
              control={control}
              name="periodoDemonstrativo"
              label="Período do demonstrativo"
              rules={{ required: true }}
              tooltip="O mês atual se refere ao mês da data de processamento."
              render={({ field }) => (
                <SelectPeriodoDemonstrativoProcessarArrecadacao {...field} />
              )}
            />

            <Field
              control={control}
              name="contasBancarias"
              label="Contas bancárias"
              rules={{ required: true }}
              render={({ field }) => (
                <SelectContasBancariasProcessarArrecadacao
                  defaultValue={
                    ArrecadacaoDemonstrativoContasBancariasEnum.Todas
                  }
                  {...field}
                />
              )}
            />
          </>
        )}
      </Flex>
    </Modal>
  );
}

export default ModalParametrosArrecadacaoAutomatica;
